<style lang="scss" scoped>
  .AppHeader {
    margin: 0;
    height: 60px;
    padding: 21px 62px 0 24px;
    background-color: #ffffff;
    color: #ffffff;
    width: 100%;
    text-align: right;
    border: solid 1px #f6f8fd;

    &__logo {
      height: 18px;
    }

    @media only screen and (max-width: 768px) {
      margin: 0;
      padding: 21px 32px 0 0;
    }
  }
</style>

<template lang="pug">
  header.AppHeader
    img.AppHeader__logo(src="@/assets/img/mobi-logo.png" alt="Mobi Lab Logo")
</template>

<script>
  export default {
    name: 'AppHeader',
  };
</script>


// WEBPACK FOOTER //
// src/components/AppHeader.vue